import React from 'react';
import './card-sec4.css'


const Cardsec4 = (props) => {
    return ( 
        <article className='cardsec4'>
            <figure className='icon-cont'>
                <img src={props.img} alt='icon'></img>
            </figure>
            <article className='text-cont-sec4'>
                <h2 className='title-card-sec4'>{props.title}</h2>
                <p className='para-sec4'>{props.para}</p>
            </article>
        </article>
     );
}
 
export default Cardsec4;